import { collection, doc } from 'firebase/firestore';
import { db } from './firebase';

// Collections
export const photosColl      = (cid: string) => collection(db, 'couples', cid, 'photos');
export const albumsColl      = (cid: string) => collection(db, 'couples', cid, 'albums');
export const nightNotesColl  = (cid: string) => collection(db, 'couples', cid, 'nightNotes');
export const tasksColl       = (cid: string) => collection(db, 'couples', cid, 'tasks');
export const musicBoxColl    = (cid: string) => collection(db, 'couples', cid, 'musicBox');
export const countdownsColl  = (cid: string) => collection(db, 'couples', cid, 'countdowns');
export const dailyAnswersColl = (cid: string) => collection(db, 'couples', cid, 'dailyAnswers');
export const heartbeatsColl  = (cid: string) => collection(db, 'couples', cid, 'heartbeats');
export const heartbeatLogsColl = (cid: string) => collection(db, 'couples', cid, 'heartbeatLogs');
export const memoryTimelineColl = (cid: string) => collection(db, 'couples', cid, 'memoryTimeline');
export const timeCapsulesColl = (cid: string) => collection(db, 'couples', cid, 'timeCapsules');
export const locationsColl   = (cid: string) => collection(db, 'couples', cid, 'locations');
export const dateIdeasColl   = (cid: string) => collection(db, 'couples', cid, 'dateIdeas');
export const wishlistColl    = (cid: string) => collection(db, 'couples', cid, 'giftWishlist');
export const activityFeedColl = (cid: string) => collection(db, 'couples', cid, 'activityFeed');
export const usersColl       = () => collection(db, 'users');

// Singleton docs
export const configDoc = (cid: string) => doc(db, 'couples', cid, 'config', 'couple');
export const moodsDoc  = (cid: string) => doc(db, 'couples', cid, 'moods', 'all');
export const petDoc    = (cid: string) => doc(db, 'couples', cid, 'pet', 'state');
export const streakDoc = (cid: string) => doc(db, 'couples', cid, 'streak', 'state');
export const cycleDoc  = (cid: string) => doc(db, 'couples', cid, 'cycle', 'state');

// Notification infrastructure
export const pushTokenDoc        = (cid: string, uid: string) => doc(db, 'couples', cid, 'pushTokens', uid);
export const notificationQueueColl = (cid: string) => collection(db, 'couples', cid, 'notificationQueue');

// Keyed docs
export const heartbeatDoc   = (cid: string, uid: string) => doc(db, 'couples', cid, 'heartbeats', uid);
export const dailyAnswerDoc = (cid: string, date: string) => doc(db, 'couples', cid, 'dailyAnswers', date);
export const taskDoc        = (cid: string, id: string) => doc(db, 'couples', cid, 'tasks', id);
export const photoDoc       = (cid: string, id: string) => doc(db, 'couples', cid, 'photos', id);
export const albumDoc       = (cid: string, id: string) => doc(db, 'couples', cid, 'albums', id);
export const nightNoteDoc   = (cid: string, id: string) => doc(db, 'couples', cid, 'nightNotes', id);
export const musicBoxDoc    = (cid: string, id: string) => doc(db, 'couples', cid, 'musicBox', id);
export const countdownDoc   = (cid: string, id: string) => doc(db, 'couples', cid, 'countdowns', id);
export const memoryDoc      = (cid: string, id: string) => doc(db, 'couples', cid, 'memoryTimeline', id);
export const timeCapsuleDoc = (cid: string, id: string) => doc(db, 'couples', cid, 'timeCapsules', id);
export const locationDoc    = (cid: string, id: string) => doc(db, 'couples', cid, 'locations', id);
export const dateIdeaDoc    = (cid: string, id: string) => doc(db, 'couples', cid, 'dateIdeas', id);
export const wishlistDoc    = (cid: string, id: string) => doc(db, 'couples', cid, 'giftWishlist', id);
export const activityFeedDoc = (cid: string, id: string) => doc(db, 'couples', cid, 'activityFeed', id);
